<template>
  <div class="productListing">
    <section class="detail_content" :class="{'paddingLess': couponResponse && !couponResponse.length || $cookie.get('app-name') === 'local91'}" >
      <header class="main_customHeading" :class="{'topZero': couponResponse && !couponResponse.length}" style="    justify-content: space-between;">
      <div class="flx">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h2>Create Shop</h2>
      </div>
      </header>
      <div class="brand-listing-page" style="margin:15px;    padding-bottom: 44px;">
        <AddShopPhoto
            @uploadImageList="previewPhoto"
          />
          <div class="field-name">
            <label>दुकान का नाम</label>
             <input type="text" v-model="shopDetail.name" placeholder="कृपया अपनी दुकान का नाम दर्ज करे"/>
          </div>
          <div class="field-name">
            <label>केटेगरी</label>
            <select v-model="shopDetail.categoryId" class="form-control cstm_field" required>
              <option
                v-for="(shopcategory, index) in shopCategoryList"
                :key="index"
                :value="shopcategory.categoryId"
              >{{shopcategory.categoryName}}</option>
            </select>
          </div>
          <div class="field-name">
            <label>पता</label>
             <textarea type="text" rows="4" v-model="shopDetail.address" placeholder="कृपया अपनी दुकान का पूरा पता दर्ज करें" id="myAddress"/>
          </div>
          <div class="field-name">
            <label>{{$t('whereDoYouWantToShowShop')}}</label>
          <div class="field-row">
            <div class="flx">
                <p class="radio-option" :class="{'active': selectedPincodeOption === 'ALL_INDIA'}" @click="getSelectedPincodeOption('ALL_INDIA')">
                        <span class="select-radio"></span>&nbsp; {{$t('allIndia')}}
                </p>
                <p class="radio-option" :class="{'active': selectedPincodeOption === 'ADD_PINCODE'}"  @click="getSelectedPincodeOption('ADD_PINCODE')">
                        <span class="select-radio"></span>&nbsp; {{$t('addPincode')}}
                </p>
                <p class="radio-option" :class="{'active': selectedPincodeOption === 'CITY_PINCODE'}"  @click="getSelectedPincodeOption('CITY_PINCODE')">
                        <span class="select-radio"></span>&nbsp; {{$t('inCity')}}
                </p>
            </div>
            
            <div v-if="selectedPincodeOption==='ADD_PINCODE'">            
              
              <input
                name="supportedPincodeList"
                type="number"
                id="text_val"
                :placeholder="$t('whereDoYouWantToShowShop') "
                @input="getSupportedPin"
                class="input-style"
                style="width: 100%; margin: 8px 0;"
              />
              <span class="error-msg" v-if="errorMsg">ऐड कहाँ दिखाना चाहते हैं ?</span>
              <ul v-if="supportedPincodeList.length" class="chiplisting" style="max-height: 148px;overflow: scroll;padding-left: 4px;padding-bottom: 4px;margin-top: 4px;border: 1px solid #ccc;border-radius: 5px;">
                <li
                  v-for="(pincode, index) in supportedPincodeList"
                  :key="index"
                >
                  <span class="text-label">{{ pincode }}</Span>
                  <span class="remove-pin" @click="removePincode(index)">
                    <close-icon />
                  </Span>
                </li>
              </ul>
          </div>
          <div v-if="selectedPincodeOption==='CITY_PINCODE'">  
              
              <div style="position:relative" class="city-action">
              <div class="flx search_bar">
              <i class="material-icons">search</i>
              <input
                name="supportedPincodeList"
                type="text"
                id="city_val"
                :placeholder="$t('searchYourCity') "
                v-on:keyup="getSearchCity($event)"
                v-model="selectedCityOption"
                class="input-style"
              />
              
              </div>
              <span class="error-msg" v-if="errorMsg">ऐड कहाँ दिखाना चाहते हैं ?</span>
              <div style="position:absolute; right:8px;height: 35px;color:#999;display:flex;align-items:center;top:0">
              <i class="material-icons" @click="isFillTitle('cityInput')" v-if="$cookie.get('version-code') > 11">mic</i>
              <span class="close-icon" v-if="searchedCityList.length && selectedCityOption" @click="closedSearchedCity()">x</span>
              </div>
              <!-- <span class="close-icon" v-if="searchedCityList.length && selectedCityOption" @click="closedSearchedCity()">x</span> -->
                <div class="city_list" v-if="searchedCityList.length && selectedCityOption">
                <h5>{{$t('selectCity')}}</h5>
                <!-- v-if="!existPincodeCity.includes(item.block)" -->
                <ul >
                  <li v-for="(item, index) in searchedCityList"                    
                    :key="index">
                    <div class="city-row"  @click="existPincodeCity.hasOwnProperty(item.block)?unSelectSearchedCity(item.block, item.state) : selectSearchedCity(item.block, item.state)"><span class="city_name"
                    :class="{active:existPincodeCity.hasOwnProperty(item.block)}">{{ item.block }} , {{item.state}}</span> <span class="material-icons">{{existPincodeCity.hasOwnProperty(item.block)? 'check_box': 'check_box_outline_blank'}}</span></div>
                    </li>
                </ul>
                </div>
              </div>
              <ul v-if="supportedPincodeList.length" class="chiplisting">    
                <li
                  v-for="(pincode, index) in supportedPincodeList"
                  :key="index" style="border:0;padding: 0;display:block;margin:0">
                  <span class="text-label" style="font-size:0">{{ pincode }}</Span>
                </li>
              </ul>         
              <ul v-if="Object.keys(existPincodeCity).length" class="chiplisting" style="max-height: 148px;overflow: scroll;padding-left: 4px;padding-bottom: 4px;margin-top: 4px;border: 1px solid #ccc;border-radius: 5px;">
              <span v-for="(value, key) in existPincodeCity"
               :key="key"> 
              <li v-for="(chip,index) in value" :key="index" >
                  <span >
                    <span class="text-label">{{ chip }}</span>
                  <span class="remove-pin" @click="removeCityPincode(key, index)">
                    <close-icon />
                  </span>
                  </span>
                  
                
                </li>
              </span>
                
              </ul>
          </div>
        </div>
          </div>
          <div class="field-name available-payment-option" style="padding:0;border:0;margin-top: 16px;">
            <label>Available Payment Options</label>
            <ul class="avilability-option">              
              <li class="list-item" @click="(shopDetail.codEnable = !shopDetail.codEnable)"><span class="item" :class="{'active':shopDetail.codEnable}"></span> COD</li>
              <li class="list-item" @click="(shopDetail.onlineEnable = !shopDetail.onlineEnable)"><span class="item" :class="{'active':shopDetail.onlineEnable }"></span> Online Payment</li>
              <li class="list-item" @click="(whatsAppEnable = !whatsAppEnable)"><span class="item" :class="{'active':whatsAppEnable }"></span> Buy on WhatsApp</li>
            </ul>
            <div class="whatsapp-input" v-if="whatsAppEnable">
              <p>Enter WhatApp Number</p>
              <input type="number" placeholder="Enter Number" v-model="shopDetail.whatsAppNumber"/>
            </div>
          </div>
          <div class="field-name">
            <label>पिनकोड</label>
             <input type="number" :placeholder="$t('sixDigitsPin')" v-model="shopDetail.pinCode" v-on:keyup="getPincodeDetails" />
          </div>
          <div class="field-name" @click="isSelectCity = !isSelectCity">
            <label>निकटतम शहर</label>
             <input type="text" v-model="shopDetail.city" />
          </div>
          <div class="field-name">
            <label>राज्य</label>
             <input type="text" v-model="shopDetail.state" />
          </div>
          <div v-if="$cookie.get('version-code') >= 94 || ($cookie.get('version-code') >=8 && $cookie.get('app-name') === 'local91')">
          <p class="selectMap" @click="openLocationMap()">मानचित्र पर स्थान का चयन करे</p>
          <div class="field-name" style="margin-top:8px;pointer-events: none;opacity: 0.8;">
             <input type="text" v-model="shopDetail.googleAddress" placeholder="मानचित्र पर स्थान" />
          </div>
          </div>
          <div class="referral-code">
            <span class="material-icons">group</span>
             <input type="text" v-model="shopDetail.referralCode" placeholder="Enter Refer Code (optional)" />
          </div>
          <div
            class="rightToLeft_content"
            :class="{'activeBottomtoUp' :isSelectCity}"
          >
          <header class="fixed_Back_header flx1">
              <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="16"
              viewBox="0 0 20 16"
              @click="isSelectCity = !isSelectCity"
            >
              <g fill="#fff" fill-rule="evenodd">
                <path
                  d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z" fill="#fff"
                />
                <path
                  d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"  fill="#fff"
                />
              </g>
            </svg>
            <input type="text" v-model="searchInput" @keyup="searchQuery($event)" class="input-bg" placeholder="Search City..." />
          </header>
          
          <div class="apply-coupon fill-value">
            <ul class="city-list">
              <li v-for="(city,index) in cityList" :key="index" @click="selectedCity(city.name)">{{city.name}}</li>
            </ul>
          </div>
       </div>   
       <span
        class="submit-btn"
        @click="validAddress()"
      >दूकान जोड़े</span>     
      </div>
      <div class="customModal" v-if="addressVerified">
      <div class="modal_dialog Cod" style="padding:0">
        <div class="modal_content" style="padding:15px">
          <div class="modal_body padding0">
            <p>{{$t('noHouseNumber')}}</p>
          </div>
        </div>
        <div class="modal_footer cod">
          <button
            type="button"
            class="order_btn cancel"
            @click="addressVerifiedFunc()"
          >{{$t('addressNotOk')}}</button>
          <button
            type="button"
            class="order_btn order-now"
            @click="createShop()"
          >{{$t('addressOk')}}</button>
        </div>
      </div>
    </div>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
  </div>
</template>

<script>
import NoDataFound from "../components/Common/NoDataFound";
import { mapGetters} from "vuex";
import CopyIcon from "@/components/Icons/CopyIcon";
import YoutubeIcon from "@/components/Icons/YoutubeIcon";
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import AddShopPhoto from '@/components/ShopCreation/AddShopPhoto'
import CustomToaster from "@/components/Common/CustomToaster";
import CloseIcon from '@/components/Icons/CloseIcon.vue';
export default {
  name: "CreateShop",
  watch: {
    goBack() {
      this.$router.go(-1);
    }
  },
  components: {
    NoDataFound,
    CopyIcon,
    YoutubeIcon,
    AddShopPhoto,
    CustomToaster,
    CloseIcon
  },
  data() {
    return {      
      loading: false,
      noRecord: false,
      shopPhotoUrl: '',
      searchedCityList: [],
      selectedCityOption: '',
      existPincodeCity:{},
      selectedPincodeOption:'',
      supportedPincodeList:[],
      shopDetail: {
        pincodes: [],
        codEnable: false,
        onlineEnable:true,
        whatsAppNumber:null,
      },
      errorMsg: false,
      isSelectCity: false,
      cityList: [],
      searchInput: "",
      shopCategoryList: [],
      addressVerified: false,
      toasterData: {},
      whatsAppEnable:false,
      isValidDetail: false,
    };
  },
  computed : {
    ...mapGetters(["couponResponse"])
  },
  methods: {
    openCouponChannel(){
      try{
        JSBridgePlugin.genericIntentLaunch("https://www.youtube.com/channel/UCM-3he3y7nnnMT17z-6ZrTQ")
      }catch{
        console.log('not allowed on browser')
      }
    },
    searchQuery(event) {
      if (
        event != null &&
        typeof event.keyCode != "undefined" &&
        event.keyCode == 13
      ) {
        this.searchInput = event.target.value;
        this.cityList = [];
        this.searchResult(this.searchInput);
      } else {
        this.searchInput = event.target.value;
        this.cityList = [];
        this.searchResult(this.searchInput);
      }
    },
    searchResult(searchInput) {
      ApiCaller(
        constant.PAYBOARD_URL,
        "user/search-city?searchTerm=" + searchInput, "get"
      )
        .then((data) => {
          if (
            data.data
          ) {
            this.cityList = data.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopCategory() {
      ApiCaller(constant.SELLER_DETAIL_URL, "shop-category", "get").then(
        (data) => {
          this.shopCategoryList = data.data;
        }
      );
    },
    selectedCity(cityName){
      this.shopDetail.city = cityName
      this.isSelectCity = !this.isSelectCity
    },
    closedSearchedCity(){
      this.searchedCityList = [];
      this.selectedCityOption = ''
    },    
    getSupportedPin(_event){
      if(_event.target.value.length == 6){   
        if (this.supportedPincodeList.includes(_event.target.value)) {
          _event.target.value = "";
          this.toasterData = {
                  msg: 'Pincode already in used',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isValidDetail = true;
              return
        }      
         this.supportedPincodeList.push(_event.target.value.trim());
         if(this.selectedPincodeOption ==='ADD_PINCODE'){
           this.waitingIcon= true
          ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${this.supportedPincodeList.toString()}`, "get").then((response) => {
            this.waitingIcon= false
              this.totalUserCount =(response.data.data.userCount)
          }).catch( err=>{
            this.waitingIcon = false
          })
         }
         _event.target.value = "";
      }
    },
    getSearchCityViaMic(res){
        this.selectedCityOption =res.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
        this.getListOfCity(this.selectedCityOption)
    },
    getSearchCity(_event){
      
      if(_event.target.value.length > 2){
        if (
          _event != null &&
          typeof _event.keyCode != "undefined" &&
          _event.keyCode == 13
        ){
          this.selectedCityOption = _event.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
          this.getListOfCity(this.selectedCityOption)
        }else {
          this.selectedCityOption = _event.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
          this.getListOfCity(this.selectedCityOption)
        }
        
        
      }
    },
    getListOfCity(cityOption){
      this.waitingIcon = true
      const obj ={
          query: cityOption,
          pageIndex: 0,
          limit: 10,
          highlight: true
        }
       ApiCaller('https://localsearch.mall91.com/search/',`suggestions/cities`, "post",obj).then((response) => {
         this.waitingIcon = false
        this.searchedCityList = response.data.pincodes;
        if(response.data.pincodes && response.data.pincodes.length && response.data.pincodes[0].block && response.data.pincodes[0].state){
          
        }else{
          this.searchedCityList = []
        }
      }).catch(err =>{
        this.waitingIcon = false
        console.log(err)
      })
    },
    selectSearchedCity(block,state){
        const payload = {
            block: block,
            state: state
          }
          this.waitingIcon = true
          ApiCaller('https://utilities.mall91.com/',`serviceability/pincodes`, "post",payload).then((response) => {
            response.data.pincodes.forEach(list=>{
              if(!this.existPincodeCity.hasOwnProperty(block)) this.$set(this.existPincodeCity,block,[])                  
              if(this.existPincodeCity.hasOwnProperty('xyz')){
                if (!this.existPincodeCity[block].includes(list.pincode) && !this.existPincodeCity['xyz'].includes(list.pincode)){
                  this.existPincodeCity[block].push(list.pincode);
                }
              }else{
                if (!this.existPincodeCity[block].includes(list.pincode)){
                  this.existPincodeCity[block].push(list.pincode);
                }
              }
              if(Object.keys(this.existPincodeCity).length){
                  let tempPincodes = []
                  for(let i in this.existPincodeCity){
                    tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
                  }
                ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${tempPincodes.toString()}`, "get").then((response) => {
                  this.waitingIcon= false
                  this.totalUserCount = response.data.data.userCount
                }).catch( err=>{
                  this.waitingIcon = false
                })
              }

            })
            this.waitingIcon = false
          }).catch(err =>{
            this.waitingIcon = false
            console.log(err)
          })
    },
    unSelectSearchedCity(block,state){
      this.$delete(this.existPincodeCity,block)
      if(Object.keys(this.existPincodeCity).length){
          let tempPincodes = []
          for(let i in this.existPincodeCity){
            tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
          }
          this.shopDetail.pincodeList = tempPincodes
        ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${tempPincodes.toString()}`, "get").then((response) => {
          this.waitingIcon= false
          this.totalUserCount = (response.data.data.userCount)
        }).catch( err=>{
          this.waitingIcon = false
        })
      }else{
        this.totalUserCount = 0
      }
    },
    removePincode(_index) {
      if(this.supportedPincodeList.length === 1 ){
        this.totalUserCount = ''
      }
        this.supportedPincodeList.splice(_index, 1);
      if(this.supportedPincodeList.length){
        ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${this.supportedPincodeList.toString()}`, "get").then((response) => {
            this.waitingIcon= false
              this.totalUserCount =(response.data.data.userCount)
          }).catch( err=>{
            this.waitingIcon = false
          })
      }else{
        this.totalUserCount = 0
      }
    },
    removeCityPincode(block,index) {
        this.existPincodeCity[block].splice(index,1)
        if(!this.existPincodeCity[block].length) this.$delete(this.existPincodeCity,block)
        if(Object.keys(this.existPincodeCity).length){
            let tempPincodes = []
            for(let i in this.existPincodeCity){
              tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
            }
            this.shopDetail.pincodeList = tempPincodes
          ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${tempPincodes.toString()}`, "get").then((response) => {
            this.waitingIcon= false
            this.totalUserCount =(response.data.data.userCount)
          }).catch( err=>{
            this.waitingIcon = false
          })
        }else{
        this.totalUserCount = 0
      }
    },
    getSelectedPincodeOption(_option){
      this.selectedPincodeOption = _option
      this.waitingIcon = true
      if(_option === 'ALL_INDIA'){
        this.totalUserCount = '12 Lakh+'
        this.waitingIcon = false
      }else{
        this.totalUserCount = ''
        this.waitingIcon = false
      }
    },
    getPincodeDetails() {
      if (this.shopDetail.pinCode.length > 5) {
        this.loading = true;
        const userPincode = this.shopDetail.pinCode;
        // this.$store
        //   .dispatch({
        //     type: "getPincodeDetails",
        //     payload: userPincode,
        //   })
          ApiCaller('https://utilities.mall91.com/serviceability/', "details/" +  userPincode, 'get')
          .then((data) => {
            this.loading = false;
            if (data.data) {
              this.shopDetail.pinCode = data.data.pincode;
              if(data.data.block != 'false'){
                this.shopDetail.city = data.data.block
              }else{
                this.shopDetail.city = ''
              }
              if(data.data.state != 'false'){
                this.shopDetail.state = data.data.state
              }else{
                this.shopDetail.state = ''
              }
              
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            if(err.response.data.errorCodes[0] === 'INVALID_PINCODE'){
              this.toasterData = {
                msg: 'Enter valid pincode',
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
            }else{
               this.toasterData = {
                msg: err.response.data.message,
                color: "#E51C24",
                iconName: "close",
              };
              this.isValidDetail = true;
            }
           
          });
      }
    },
    previewPhoto(photofile) {
      this.shopDetail.image = photofile;
    },
    openLocationMap(){
      //object and array are not reactive 
      // specific indiex not reactive
      try {
        _OPENMAP.openLocationPicker = res => {
            let locationResponse;
            locationResponse = JSON.parse(res)
            console.log(locationResponse.address)
          if(locationResponse.pincode){
            this.shopDetail.pinCode= locationResponse.pincode
          }
          if(locationResponse.latLng){
            let response;
            response = locationResponse.latLng
            let getValue;
            getValue = response.split(':')[1]
            let latitude;
            latitude = getValue.split(',')[0]
            let longitude;
            longitude = getValue.split(',')[1]
            this.$set(this.shopDetail,'latitude', latitude.split('(')[1])
            this.$set(this.shopDetail,'longitude', longitude.split(')')[0])
          }
          if(locationResponse.address){
            this.$set(this.shopDetail,'googleAddress', locationResponse.address)
          }
        };
        JSBridgePlugin.openLocationPicker("_OPENMAP.openLocationPicker");
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    validateFields() {
       
      const obj = this.shopDetail;

      if (
        !obj.name ||
        !obj.image ||
        !obj.categoryId ||
        !obj.address ||
         !obj.pinCode ||
        !obj.city  ||
        !obj.state
      ) {
        let fieldName;
        if(!obj.name){          
          fieldName = 'enter shop name'          
        }else if(!obj.image){
          fieldName = 'select shop image'
        }else if(!obj.categoryId){
          fieldName = 'select shop category'
        }else if(!obj.address){
          fieldName = 'add shop address'
        }else if(!obj.city){
          fieldName = 'enter city name'
        }else if(!obj.pinCode){
          fieldName = 'enter pincode'
        }else if(!obj.state){
          fieldName = 'enter state name'
        }
        this.toasterData = {
            msg: `Please ${fieldName}`,
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        
      } else {
        if (obj.name.length > 4 && obj.name.length < 30) {
          if (new RegExp(/^[0-9 ]{5,30}$/g).test(obj.name)) {
            this.toasterData = {
              msg: this.$t("enterValidName"),
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        }else{
          this.toasterData = {
              msg: this.$t("enterValidName"),
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
        }
        if (obj.address.length > 10) {
          if (new RegExp(/^[0-9 ]{10,200}$/g).test(obj.address)) {
            this.toasterData = {
              msg: this.$t("validAddressMsg"),
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        }else{
          this.toasterData = {
            msg: this.$t("enterValidAddress", { addresslength: "10" }),
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
        if (new RegExp(/^[0-9 ]{1,200}$/g).test(obj.state)) {
            this.toasterData = {
              msg: this.$t("enterValidState"),
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        if (obj.pinCode.length != "") {
          if (!new RegExp(/^[1-9][0-9]{5}$/g).test(obj.pinCode)) {
            this.toasterData = {
              msg: this.$t("enterValidPinNumber"),
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        }
        return true;
      }
    },
    addressVerifiedFunc(){
      this.addressVerified = !this.addressVerified;
      document.getElementById("myAddress").focus();
    },
    validAddress() {
      if (this.validateFields()) {
        if(this.selectedPincodeOption){
            if(this.selectedPincodeOption ==='ALL_INDIA'){
              this.shopDetail.pincodes = []
            }else if(this.selectedPincodeOption ==='ADD_PINCODE'){
            if(this.supportedPincodeList.length){
                this.shopDetail.pincodes = this.supportedPincodeList
            }else{
                this.toasterData = {
                  msg: 'दुकान कहाँ दिखाना चाहते हैं ?',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isValidDetail = true;
                return false
            }
            }else if(this.selectedPincodeOption ==='CITY_PINCODE'){
            if(Object.keys(this.existPincodeCity).length){
                let tempPincodes = []
                for(let i in this.existPincodeCity){
                    tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
                }
                //  this.$set(this.shopDetail,'pincodeList',tempPincodes)
                this.shopDetail.pincodes = tempPincodes
            }else{
                this.toasterData = {
                  msg: 'दुकान कहाँ दिखाना चाहते हैं ?',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isValidDetail = true;
                return false
            }
          }
          // this.createShop()
        }else{
          this.toasterData = {
            msg: 'Choose Shop location',
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
            return false
        }
        if(this.shopDetail.codEnable || this.shopDetail.onlineEnable || this.whatsAppEnable){
          if(this.whatsAppEnable){
          if(!this.shopDetail.whatsAppNumber){
            this.toasterData = {
              msg: 'Please Enter WhatsApp Number',
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false
          }else{
            if (
              !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(this.shopDetail.whatsAppNumber)
            ) {
              this.toasterData = {
                msg: this.$t("enterValidMobileNumber"),
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          }
        }
          
         this.shopDetail.paymentCollectionEnable = true
         console.log(this.shopDetail)
        this.createShop()
        }else{
          this.toasterData = {
              msg: 'Please select payment option to create shop',
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
        }
        
      }
    },
    createShop(){
      this.loading = true;
      ApiCaller(constant.SHOP_SERVICE_URL, "createShop", "post", this.shopDetail).then(
        (data) => {
          this.loading = false;
          this.toasterData = {
            msg: 'Shop created successfully',
            color: "#138808",
            iconName: "check",
          };
          this.isValidDetail = true;
          setTimeout(() => {
            this.$router.push('/local-shops?createdShopRedirect=true')
          }, 1000);
          
        }
      ).catch(err =>{
        this.loading = false;
        if(err.response.data.errorCodes[0] === 'INVALID_REFERRAL_CODE'){
          this.toasterData = {
            msg: 'Enter valid referral code',
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
        }
        if(err.response.data.errorCodes[0] === 'INVALID_SHOP_NAME'){
          this.toasterData = {
            msg: 'Enter valid Shop name',
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
        }
        if(err.response.data.errorCodes[0] === 'SHOP_CREATION_DISABLED_FOR_SELLER'){
          this.toasterData = {
            msg: 'You are not allowed to create shop',
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
        }else{
          this.toasterData = {
            msg: err.response.data.message,
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
        }
        console.log(err)
      })
    }
    
  },
  mounted() {
    this.getShopCategory();
    if(this.$store.state.userInfo.pincode){
      this.$set(this.shopDetail,'pinCode', this.$store.state.userInfo.pincode)
      this.$set(this.shopDetail,'city', this.$store.state.userInfo.city.name)
      this.getPincodeDetails()
    }
  }
};
</script>
<style lang="scss" scoped>
.productListing .detail_content .main_customHeading.topZero{
  top: 0
}
.productListing .detail_content .main_customHeading.topHeight{
  top: 44px;
  box-shadow: 0 0px 6px 0 rgb(0 0 0 / 16%);
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
.paddingTop, .productListing .detail_content.paddingTop{
  padding-top: 0;
}
.productListing .detail_content.paddingMore{
  padding-top: 95px;
  padding-bottom: 0;
}
.field-name{
  margin-bottom: 8px;
  &.wdth50{
    input{
      width: 48%;
    margin-right: 4%;
    &:last-child{
      margin-right: 0;
    }
    }
  }
  label{
    font-size: 0.875em;
    color: #484848;
    margin-bottom: 8px;
    display: block;
  }
  input, textarea, select{
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 8px;
    font-size: 0.938em;
    color: #484848;
    font-weight: 500;
    width: 100%;
    &::placeholder{
      color: #999;
    }
  }
}
.selectMap{
  background: #EAEAEA;
  padding: 8px;
  text-align: center;
  border-radius: 25px;
  border: 1px solid #D9D9D9;
  font-weight: bold;
  margin-top:15px;
}
.referral-code{
  position: relative;
  margin: 15px 0;
    border: 1px dashed #5ca6e2;
    padding: 8px;
    padding-left: 35px;
    input{
      color: #5ca6e2;
      font-weight: 500;
      &::placeholder{
        color: #5ca6e2;
        font-weight: 500;
      }
    }
    .material-icons{
     position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
     color: #5ca6e2;
    }
}
.rightToLeft_content {
    visibility: hidden;
    position: fixed;
    bottom: 0;
    top:0;
    right: 0;
    min-height: 165px;
    left: 0;
    width: 100%;
    z-index: 99;
    max-width: 767px;
    background: #fff;
    transition: all ease-in 0.5s;
    transform: translateX(200%);
    // padding: 15px 0;
        background-color: #f4f6f8;

    &.activeBottomtoUp {
      transform: translateX(0%);
      visibility: visible;
    }
    .flx1{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: blue;
      h4{
        color: #000;
        padding-left: 8px;
      }
      input{
        background: blue;
        color: #fff;
        border-bottom: 1px solid #fff;
        font-size: 1.05em;
        &::placeholder{
          color: #fff;
        }
      }
      svg{
         margin-right:15px;
        path{
          fill:#fff;
         
        }
      }
    }
}
.city-list{
  li{
        padding: 8px 15px;
    border-bottom: 1px solid #ccc;
  }
}
.submit-btn{
      display: block;
    background-color: green;
    font-size: 1.125em;
    padding: 10px;
    font-weight: 600;
    border-radius: 4px;
    color: white;
    text-align: center;
    margin-top: 24px;
    position: fixed;
    bottom: 8px;
    width: calc(100% - 30px);
}
.radio-option{
        display: flex;
        margin-bottom: 8px;
        font-size: 0.875em;
        .text{            
            margin-left: 8px;
        }
        &.active{
            .select-radio{
                &::after{
                    content: '';
                    width: 13px;
                    height: 13px;
                    position: absolute;
                    background: green;
                    border-radius: 50%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50% , -50%);
                }
            }
        .text{
            color: green;
            font-weight: 600;
        }
        }
    }
    .select-radio{
        content: '';
        width: 20px;
        height: 20px;
        display: inline-block;
        border: 1px solid green;
        border-radius: 50%;
        position: relative;
    }
    .city-action{
    .text-label{
        margin: 0;
    }
.close-icon{
    display: block;
    width: 20px;
    height: 20px;
    // position: absolute;
    // right: 8px;
    // top: 50%;
    background: orange;
    padding: 7px;
    border-radius: 50%;
    line-height: 0.3;
    z-index: 99;
    // transform: translateY(-50%);
    margin-left:8px;
    color:#000;
}
.search_bar{
      border: 1px solid #ccc;
    padding: 8px;
    border-radius: 25px;
    margin-top: 8px;
    i{
          font-size: 20px;
    padding-right: 8px;
        color: #838485;
    }
}
.input-style{
  width: 100%;
    margin-top: 8px;
    border-radius: 25px;
    border: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
        text-transform: capitalize;

}
.city_list{
  // position: absolute;
  //   top: 40px;
    background: #fff;
    z-index: 9;
    width: 100%;
    left: 0;
    box-shadow: 0 0px 30px 0px rgb(0 0 0 / 25%);
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 5px;
    .city-row{
      width: 100%;
    justify-content: space-between;
    display: flex;
    align-items: center;
    }
    .city_name{
      width: 60%;
      &.active{
        color: green;
        font-weight: 600;
      }
    }
    h5{
    margin-bottom: 8px;
    }
    ul{
      border: 1px solid #ccc;
      max-height: 120px;
      overflow: scroll;
      border-radius: 5px;
      padding: 8px;
      // padding-bottom: 0;
    li{
        padding: 4px 0;
        display:flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ccc;
        font-size: 0.875em;
        font-weight: 500;
        color: #505050;
          &:last-child{
            border-bottom: none;
          }
    }
    }
}
}
.chiplisting li {
    width: auto;
    background: #fff;
    border-radius: 25px;
    border: 1px solid #dddddd;
    padding: 4px 28px 4px 8px;
    margin: 4px 2px 0 0;
    display: inline-block;
    position: relative;
    line-height: 0;
    .text-label {
    font-size: 0.75em;
    color: #505050;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    margin-bottom: 0px;
}
.remove-pin {
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    position: absolute;
    right: 4px;
    top: 3px;
}
}
.field-row .input-style {
    width: 100%;
    height: auto;
    padding: 8px;
    border: 1px solid #D9D9D9;
    color: #000;
    font-size: 0.875em;
    border-radius: 6px;
    line-height: 1.5;
}
</style>